import axios from "axios";
//import crashlytics from '@react-native-firebase/crashlytics';
// const RNFS = require('react-native-fs');
// const path = RNFS.ExternalStorageDirectoryPath+ '/SSSlog.txt';

export const sendRequest = (URL, method = "GET", data, option, callback) => {
  console.log(URL);

  var headers = { "Content-Type": "application/json" };
  // if (option.headers) {
  //   headers = { ...headers, ...option.headers };
  // }
  var fetchParams = {
    method: method,
    headers: headers
  };
  /*****************
   * START
   * Description: send request as post
   * Dependencies: Internet connection
   * @returns {Promise<void>}
   */
  if (method === "POST" || method === "PUT") {
    console.log('PUT')
    fetchParams.body = JSON.stringify(data);
    console.log('response fcm sent',fetchParams.body)  
    console.log("BEFORE SEND REQUEST")
    axios({
      method: fetchParams.method,
      url: URL,
      data: fetchParams.body,
      // headers: fetchParams.headers
    })
      .then(response => {
        console.log("on response ")
        console.log(response)
        return response;
      })
      .then(function(data) {
        console.log("DATA POSTED ")
        console.log(data)
        console.log(data.data)
        if (data.status === false && data.response.error === "INVALID_TOKEN") {
          alert("Something went wrong");
        }
        callback(null, data);
      })
      .catch(error => {
        console.log(error.response)
        //callback(error, {})
        //console.log(error.response.data.message)
        console.log(error.response)
      });
  }
  /*****************
   * START
   * Description: send request as get
   * Dependencies: Internet connection
   * @returns {Promise<void>}
   */
  else {
    axios({
      method: fetchParams.method,
      url: URL,
      headers: fetchParams.headers
    })
      .then(response => {
        return response;
      })
      .then(function(data) {
        console.log(data)
        if (data.status === false && data.response.error === "INVALID_TOKEN") {
          alert("Something went wrong");
        }
        callback(null, data);
      })
      .catch(error => {
        console.log(error)
        callback("Error Occurred, Try Again Later",{})
        /*
        if(error)
        {
          var obj ={}
          obj.status = 'error'
          callback("error",null )
        }
        else
        {
          if (error.response && error.response.status) {
            if (error.response.data && error.response.data.Message && typeof(error.response.data.Message) === 'string') {
              callback(error.response.data.Message, {});
            } else {
              callback("Something Went Wrong. Contact Administrator", {})
            }
          } else {
            if (error.response.data && typeof(error.response.data) === 'string') {
              callback(error.response.data, {});
            } else {
              callback("Something Went Wrong. Contact Administrator", {})
            }
          }
        }
        */

        console.log(error.response)
      })
  }
};
